import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { Form } from '@carsys/form'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { PaymentMethodsField } from 'app/settings/components/PaymentMethods/Fields'
import { defaultStepFormProps } from '../types.d'
import { FormResult, FormValues } from './types.d'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'

const nonEmptyValues = (input: object): object => {
  const entriesWithActualValues = Object.entries(input).filter(([_, value]) => !!value)
  return Object.fromEntries(entriesWithActualValues)
}
interface PaymentMethodsForm {
  onSubmit: (values: any) => any
}

export const PaymentMethodsForm: React.FC<defaultStepFormProps & PaymentMethodsForm> = ({
  onSubmit,
  prevStep,
  isFirstStep,
  isPersisting,
  onSubmitSuccess,
  hideSkip,
  shouldRunInBackground,
  initialData
}) => {
  const { t } = useTranslation()

  const initialValues = {
    Code: '',
    Name: '',
    Description: '',
    IsEnabled: true,
    PreventAccountancyExport: false,
    ...nonEmptyValues(initialData)
  }

  return (
    <BaseStepLayout title={t('onboarding.payment_methods.step_header')} subTitles={[t('onboarding.payment_methods.step_info')]}>
      <Form<FormValues, FormResult>
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={initialValues}
        NavigationConfirmation={null}
        enableReinitialize
      >
        {({ isSubmitting, handleSubmit }) => (
          <WithRunInBackgroundHelper enabled={shouldRunInBackground} isSubmitting={isSubmitting} onSubmit={handleSubmit}>
            <Box>
              <PaymentMethodsField />
            </Box>
            <StepNavigation prevStep={prevStep} hideBack={isFirstStep} isLoading={isSubmitting || isPersisting} hideSkip={hideSkip} />
          </WithRunInBackgroundHelper>
        )}
      </Form>
    </BaseStepLayout>
  )
}
